import { Box, Divider, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";


export default function InfoBox({title, children, color = "#bbb", titleColor = "#777", backgroundColor, ...props}) {
    return (
  <Box
    sx={{
      mt: 1,
      borderRadius: 2,
      backgroundColor: backgroundColor ? backgroundColor : alpha(color, 0.04),
      border: "1px solid",
      borderColor: alpha(color, 0.3),
      borderLeft: "4px solid",
      borderLeftColor: alpha(color, 0.6),
      overflow: "hidden",
      px: 1.5,
      py: 1.25,
      ...props.sx,
    }}
  >
    <Typography
      variant="body2"
      fontWeight="bold"
      sx={{
        color: titleColor,
        mb: 0.5,
      }}
    >
      {title}
    </Typography>

    <Typography
      variant="caption"
      color="text.secondary"
      component="div"
      sx={{
        lineHeight: 1.8,
      }}
    >
      {children}
    </Typography>
  </Box>
);
}